import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Bulk fetch review summaries for a list of product handles.
 * Returns { handleA: { total, average }, handleB: {...} }
 */
export function useReviewsSummary(handles) {
    const [map, setMap] = useState({});
    const key = (handles || []).join(",");

    useEffect(() => {
        if (!handles || handles.length === 0) {
            setMap({});
            return;
        }
        api.get(`/reviews-summary?handles=${encodeURIComponent(key)}`)
            .then((r) => setMap(r.data || {}))
            .catch(() => setMap({}));
    }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

    return map;
}
